<script>
import CustomIcon from 'dashboard/components/ui/CustomIcons.vue';

export default {
  name: 'ClassificationBadge',
  components: {
    CustomIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    data() {
      const classifications = {
        POSITIVE: {
          label: 'Positivo',
          textColor: 'text-[#0C8312]',
          bgColor: 'bg-[#D6FFD8]',
          iconColor: '#0C8312',
        },
        NEGATIVE: {
          label: 'Negativo',
          textColor: 'text-[#DF4C50]',
          bgColor: 'bg-[#FFE7EB]',
          iconColor: '#DF4C50',
        },
        NEUTRAL: {
          label: 'Neutro',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#60646C',
        },
        IRONY: {
          label: 'Ironia',
          textColor: 'text-[#7B8D0A]',
          bgColor: 'bg-[#FAFFDC]',
          iconColor: '#7B8D0A',
        },
        SPAM: {
          label: 'Spam',
          textColor: 'text-[#DC7D3B]',
          bgColor: 'bg-[#FAFFDC]',
          iconColor: '#DC7D3B',
        },
        AI_REPLY: {
          label: 'Seeyu',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#FFFFFF]',
          iconColor: '#60646C',
        },
      };
      return (
        classifications[this.type] || {
          label: 'Desconhecido',
          textColor: 'text-[#000000]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#000000',
        }
      );
    },
  },
};
</script>

<template>
  <div
    :class="`flex items-center gap-2 rounded-lg p-2 text-xs font-semibold ${data.bgColor} ${data.textColor}`"
  >
    <CustomIcon group="classification" :name="type" :color="data.iconColor" />
    <span class="flex-shrink-0">{{ data.label }}</span>
  </div>
</template>
